export const contactSentimentMap = {
    positive: {
        face: '😀',
        label: 'contact.sentiment.positive',
    },
    neutral: {
        face: '😐',
        label: 'contact.sentiment.neutral',
    },
    negative: {
        face: '😕',
        label: 'contact.sentiment.negative',
    },
} as const;

export type ContactSentiment = keyof typeof contactSentimentMap;
